"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var white = '#ffffff';
var black = '#000000';
var brandBlue = '#0082ff';
var modalOverlay = '#21212160';
var gray = {
  50: '#f6f7f9',
  100: '#e1e6ec',
  200: '#cbd4de',
  300: '#afbdcc',
  400: '#94a7ba',
  500: '#7890a8',
  600: '#537495',
  700: '#3b5261',
  800: '#2f3f4b',
  900: '#26323c'
};
var blue = {
  50: '#f6fbfd',
  100: '#e6f8fd',
  200: '#c0e9fb',
  300: '#96d3fa',
  400: '#5baafa',
  500: '#1271eb',
  600: '#1d58f2',
  700: '#1b46da',
  800: '#1735a6',
  900: '#132b7f'
};
var navy = {
  50: '#f4fafc',
  100: '#e4f7fb',
  200: '#bfebf6',
  300: '#92d9f4',
  400: '#51b7f0',
  500: '#2590ea',
  600: '#1a6cda',
  700: '#1b55b6',
  800: '#194185',
  900: '#002d5b'
};
var green = {
  50: '#ecf8f7',
  100: '#d3f7ef',
  200: '#a4f3d9',
  300: '#65eabf',
  400: '#1edb96',
  500: '#09c66a',
  600: '#08ad50',
  700: '#008547',
  800: '#11703e',
  900: '#115a35'
};
var yellow = {
  50: '#f9f5e5',
  100: '#faf0bd',
  200: '#f6e67c',
  300: '#f1d439',
  400: '#ffbf02',
  500: '#e19706',
  600: '#cf7404',
  700: '#ae5708',
  800: '#8e440e',
  900: '#743710'
};
var red = {
  50: '#fdf9f8',
  100: '#fdeef3',
  200: '#fbcee6',
  300: '#fba4d1',
  400: '#fc6bad',
  500: '#fc4086',
  600: '#f7265f',
  700: '#e01438',
  800: '#b4193c',
  900: '#901530'
};
var colors = {
  gray: _objectSpread(_objectSpread({}, gray), {}, {
    light: gray['50'],
    medium: gray['200'],
    dark: gray['600']
  }),
  blue: blue,
  navy: navy,
  red: _objectSpread(_objectSpread({}, red), {}, {
    "default": red['700']
  }),
  green: _objectSpread(_objectSpread({}, green), {}, {
    "default": green['700']
  }),
  yellow: _objectSpread(_objectSpread({}, yellow), {}, {
    "default": yellow['400']
  }),
  primary: _objectSpread(_objectSpread({}, blue), {}, {
    "default": blue['500']
  }),
  secondary: _objectSpread(_objectSpread({}, navy), {}, {
    "default": navy['900']
  }),
  success: green['700'],
  warning: yellow['400'],
  error: red['700'],
  accent: gray['200'],
  text: {
    primary: {
      light: black,
      dark: white
    },
    secondary: {
      light: gray['600']
    },
    link: {
      light: blue['500'],
      dark: white
    }
  },
  background: {
    gray: gray['50'],
    white: white
  },
  white: white,
  black: black,
  brandBlue: brandBlue,
  modalOverlay: modalOverlay
};
var _default = exports["default"] = colors;